module.exports = __webpack_public_path__ + "img/pic_03.459c9e14.svg";